import { createContext } from 'react';

export const store = createContext(null);
export const initialState = {
    report:null,
    progress:false,
    filters:{start:null,end:null},
    page:1,
}
export const reducer = (state,actions)=>{
    const {payload,type} = actions;
    switch (type) {
        case 'REPORT':
            return {...state,report:payload};
        case 'PROGRESS':
            return {...state,progress:payload};
        case 'PAGE':
            return {...state,page:payload};
        case 'CHANGE_START_DATE':
            return {...state,filters:{...state.filters,start:payload}};
        case 'CHANGE_END_DATE':
            return {...state,filters:{...state.filters,end:payload}};
        default:
            return {...state}
    }
}